/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetTeamTreeQueryResponse, TransferCustomersControllerGetTeamTreePathParams, TransferCustomersControllerGetTeamTree401, TransferCustomersControllerGetTeamTree403 } from "../../models/transferCustomersController/TransferCustomersControllerGetTeamTree";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferCustomersControllerGetTeamTree } from "../../clients/transfer-customersService/transferCustomersControllerGetTeamTree";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferCustomersControllerGetTeamTreeQueryKey = (salesforceId: TransferCustomersControllerGetTeamTreePathParams["salesforceId"], teamUuid: TransferCustomersControllerGetTeamTreePathParams["teamUuid"]) => [{
  url: '/api/v1/transfer-customers/:salesforceId/teams/:teamUuid/tree',
  params: {
    salesforceId: salesforceId,
    teamUuid: teamUuid
  }
}] as const;
export type TransferCustomersControllerGetTeamTreeQueryKey = ReturnType<typeof transferCustomersControllerGetTeamTreeQueryKey>;
export function transferCustomersControllerGetTeamTreeQueryOptions(salesforceId: TransferCustomersControllerGetTeamTreePathParams["salesforceId"], teamUuid: TransferCustomersControllerGetTeamTreePathParams["teamUuid"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferCustomersControllerGetTeamTreeQueryKey(salesforceId, teamUuid);
  return queryOptions<TransferCustomersControllerGetTeamTreeQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetTeamTree401 | TransferCustomersControllerGetTeamTree403>, TransferCustomersControllerGetTeamTreeQueryResponse, typeof queryKey>({
    enabled: !!(salesforceId && teamUuid),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferCustomersControllerGetTeamTree(salesforceId, teamUuid, config);
    }
  });
}

/**
 * @summary Get folder/project/crunch tree for a team
 * {@link /api/v1/transfer-customers/:salesforceId/teams/:teamUuid/tree}
 */
export function useTransferCustomersControllerGetTeamTree<TData = TransferCustomersControllerGetTeamTreeQueryResponse, TQueryData = TransferCustomersControllerGetTeamTreeQueryResponse, TQueryKey extends QueryKey = TransferCustomersControllerGetTeamTreeQueryKey>(salesforceId: TransferCustomersControllerGetTeamTreePathParams["salesforceId"], teamUuid: TransferCustomersControllerGetTeamTreePathParams["teamUuid"], options: {
  query?: Partial<QueryObserverOptions<TransferCustomersControllerGetTeamTreeQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetTeamTree401 | TransferCustomersControllerGetTeamTree403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferCustomersControllerGetTeamTreeQueryKey(salesforceId, teamUuid);
  const query = useQuery({
    ...transferCustomersControllerGetTeamTreeQueryOptions(salesforceId, teamUuid, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferCustomersControllerGetTeamTree401 | TransferCustomersControllerGetTeamTree403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}